import { ICorrectAnswerRateValue } from "@/consts/interfaces";

const CORRECT_ANSWER_RATE_TYPE: Array<ICorrectAnswerRateValue> = [
  {name: "学習進捗と初回正答率の分布をみる", value: 1},
  {name: "学習進捗と最新正答率の分布をみる", value: 2},
]

const CORRECT_ANSWER_RATE_TYPE_LABEL_MAP: { [id: number] : string } = {
    1: "初回正答率",
    2: "最新正答率"
}

export {CORRECT_ANSWER_RATE_TYPE, CORRECT_ANSWER_RATE_TYPE_LABEL_MAP}
